import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-activity-photos',
  templateUrl: './activity-photos.component.html',
  styleUrls: ['./activity-photos.component.scss']
})
export class ActivityPhotosComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  fullWidth=false;
  showSideMenu = true;
  showHeading = false;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 6){
      this.showSideMenu=true;
      this.fullWidth=false;
      this.showHeading = true;
    }
    else if((url.length === 7 && (url[6]==='2021-22' || url[6]==='2020-21' || url[6]==='2019-20' || url[6]==='2018-19'))){
      this.showSideMenu=true;
      this.fullWidth=false;
      this.showHeading = false;
    }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
      this.showHeading = false;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
